import React, { useCallback } from 'react'
import { utils } from '@pay24/common'
import { useDropzone } from 'react-dropzone'
import { View } from 'react-native'

const { fileToBase64 } = utils

interface UploadProperty {
  onChange: (image: any, name?: string) => void
  camera?: boolean
  children?: any
  style?: any
  multiple?: boolean
  withBase64?: boolean
}

export default ({
  onChange,
  children,
  style,
  multiple = false,
  withBase64 = true,
}: UploadProperty) => {
  const onDrop = useCallback(
    async (files) => {
      if (files && files.length) {
        const file = multiple ? files : files[0]
        if (!onChange) return

        if (withBase64) {
          if (multiple) {
            for (let f of file) {
              const bas64String = await fileToBase64(f)
              onChange(bas64String, f.name)
            }
          } else {
            const bas64String = await fileToBase64(file)
            onChange(bas64String, file.name)
          }
        } else {
          if (multiple) {
            for (let f of file) {
              onChange(f)
            }
          } else {
            onChange(file)
          }
        }
      }
    },
    [multiple, onChange, withBase64],
  )

  const dropzoneOptions = {
    accept: ['image/*'],
    maxFiles: multiple ? 15 : 1,
    maxSize: 10 * 1024 * 1024,
    multiple,
  } as any
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    ...dropzoneOptions,
  })

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <View style={style}>{children}</View>
    </div>
  )
}
